import DEFAULT_IMG from 'assets/img/binders.png';
import { useEffect, useState } from 'react';
import { getImage } from 'utils/gallery';

type Props = {
  src?: string;
};

export const RevxGalleryImg = (props: Props) => {
  const { src } = props;
  const [imgSrc, setImgSrc] = useState<string>(
    getImage(src || '', DEFAULT_IMG)
  );
  useEffect(() => {
    setImgSrc(getImage(src || '', DEFAULT_IMG));
  }, [src]);
  return (
    <>
      <img
        src={imgSrc}
        alt="none"
        onError={function (e) {
          setImgSrc(DEFAULT_IMG);
        }}
      />
    </>
  );
};
